module.exports = __webpack_public_path__ + "img/pic_3.f0878731.jpg";